import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Link from '../../utils/link';

const HedStyles = (props) => css`
  font-size: ${props.theme.modularScale.small};
  font-family: ${props.theme.font.caption};
  letter-spacing: 0.25em;
  line-height: 1.4rem;
  text-decoration: none;
  text-transform: uppercase;
  padding-bottom: 0.8rem;
  border-bottom: 0.2rem solid ${props.theme.color.brand};
`;

const StyledAnchor = styled.a`
  color: ${(props) => props.theme.color.brand};
  font-family: ${(props) => (props.uppercase ? props.theme.font.caption : 'inherit')};
  font-size: ${(props) => props.theme.modularScale.small};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : '')};
  letter-spacing: ${(props) => (props.uppercase ? '0.25em' : '')};

  :visited {
    color: ${(props) => (props.hed ? props.theme.color.brandLight : props.theme.color.brand)};
  }

  ${(props) => (props.hed ? HedStyles : '')}
`;

const Anchor = (props) => (!props.prefetch ? (
  <Link prefetch={false} href={props.href} passHref>
    <StyledAnchor
      onClick={props.onClick}
      className={props.className}
      hed={props.hed}
      underline={props.underline}
      uppercase={props.uppercase}
    >
      { props.children }
    </StyledAnchor>
  </Link>
) : (
  <Link href={props.href} passHref>
    <StyledAnchor
      onClick={props.onClick}
      className={props.className}
      hed={props.hed}
      underline={props.underline}
      uppercase={props.uppercase}
    >
      { props.children }
    </StyledAnchor>
  </Link>
));

Anchor.defaultProps = {
  children: '',
  className: '',
  hed: false,
  href: null,
  prefetch: true,
  underline: false,
  uppercase: false,
  onClick: () => {}
};

Anchor.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any,
  className: PropTypes.string,
  hed: PropTypes.bool,
  href: PropTypes.string,
  prefetch: PropTypes.bool,
  underline: PropTypes.bool,
  uppercase: PropTypes.bool
};

export { HedStyles as hedStyles };

Anchor.whyDidYouRender = true;

export default Anchor;
